import { cn } from '@/lib/utils'

export type DotTone = 'good' | 'warn' | 'bad' | 'info' | 'neutral'

const dotColors: Record<DotTone, string> = {
  good: 'bg-emerald-500',
  warn: 'bg-amber-500',
  bad: 'bg-red-500',
  info: 'bg-blue-500',
  neutral: 'bg-zinc-400',
}

type DotProps = {
  tone?: DotTone
  className?: string
}

export function Dot({ tone = 'neutral', className }: DotProps) {
  return (
    <span
      className={cn('inline-block h-2 w-2 shrink-0 rounded-full', dotColors[tone], className)}
      aria-hidden="true"
    />
  )
}

export default Dot
